module.exports = __webpack_public_path__ + "img/location-shopping.fba11f1a.svg";